interface GetPhotoCheckerPendingAlertContentParams {
  isResultStale: boolean;
  isAutoModeMissedCheck: boolean;
  showManualActionButton: boolean;
  isNotFound: boolean;
}

export function getPhotoCheckerPendingAlertContent(
  params: GetPhotoCheckerPendingAlertContentParams
) {
  const messageKey = getMessageKey(params);
  const secondaryMessage = getSecondaryMessage(params);
  const actionKey = getActionKey(params);

  return {messageKey, secondaryMessage, actionKey};
}

function getMessageKey(
  params: Pick<GetPhotoCheckerPendingAlertContentParams, 'isResultStale' | 'isAutoModeMissedCheck'>
) {
  if (params.isAutoModeMissedCheck && params.isResultStale) {
    return 'entity.photoChecker.labels.autoModeMissedUpdatedPhotos';
  }

  if (params.isAutoModeMissedCheck) {
    return 'entity.photoChecker.labels.autoModeMissedExistingPhotos';
  }

  if (params.isResultStale) {
    return 'entity.photoChecker.labels.photosUpdatedSinceLastCheck';
  }

  return 'entity.photoChecker.labels.photosReadyForFirstCheck';
}

function getSecondaryMessage(params: GetPhotoCheckerPendingAlertContentParams) {
  if (params.showManualActionButton) {
    return undefined;
  }

  if (params.isAutoModeMissedCheck && params.isResultStale) {
    return 'entity.photoChecker.labels.autoModeMissedUpdatedManualAction';
  }

  if (params.isAutoModeMissedCheck) {
    return 'entity.photoChecker.labels.autoModeMissedManualAction';
  }

  if (params.isResultStale) {
    return 'entity.photoChecker.labels.updatedCheckRunsAutomatically';
  }

  return 'entity.photoChecker.labels.firstCheckRunsAutomatically';
}

function getActionKey(
  params: Pick<
    GetPhotoCheckerPendingAlertContentParams,
    'isResultStale' | 'isAutoModeMissedCheck' | 'isNotFound'
  >
) {
  if (params.isResultStale || (params.isAutoModeMissedCheck && !params.isNotFound)) {
    return 'entity.photoChecker.actions.updateCheck';
  }

  return 'entity.photoChecker.actions.checkPhotoQuality';
}
